import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CustomCmsItemComponentData } from '../custom-cms-item/custom-cms-item.model';
import { CustomOurBrandsComponentData } from './custom-our-brands.model';
import {
  CustomCmsEventService
} from "src/app/spartacus/features/tracking/custom-events/checkout/cms/custom-cms-event.service";

@Component({
  selector: 'app-custom-our-brands',
  templateUrl: './custom-our-brands.component.html',
  styleUrls: ['./custom-our-brands.component.scss'],
  standalone: false
})
export class CustomOurBrandsComponent implements AfterViewInit, OnDestroy {
  animation = 'swipe';
  protected subscriptions: Subscription = new Subscription();

  constructor(
    protected componentData: CmsComponentData<CustomOurBrandsComponentData>,
    protected breakpointService: BreakpointService,
    private cmsService: CmsService,
    private customCmsEventService: CustomCmsEventService,
  ) {
  }

  data$ = this.componentData.data$.pipe(map(component => component));

  items$: Observable<Observable<CustomCmsItemComponentData>[]> = this.componentData.data$.pipe(
    map((data) => data.items.trim().split(' ').map((codes: string) => this.cmsService.getComponentData(codes)))
  );

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.sm);
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.items$.pipe(take(1)).subscribe(items => {
        const bannerList = this.customCmsEventService.getComponentList(items);
        this.customCmsEventService.dispatchViewPromotionEvent(bannerList);
      })
    )
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
